<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn
        v-bind="activatorProps"
        block
        variant="tonal"
        color="error"
        prepend-icon="mdi-power"
        class="int-logout-btn"
      >Log out</v-btn>
    </template>

    <v-card prepend-icon="mdi-power" title="Log out?">
      <v-card-text class="text-left text-body-2 text-medium-emphasis">
        You'll need to sign in again to access your tickets and boards.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="logout(false)">Cancel</v-btn>
        <v-btn color="error" variant="flat" @click="logout(true)">Log out</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LogoutPage',
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    logout(logout) {
      this.dialog = !this.dialog;
      this.$emit('toggle-loading', logout);
    },
  },
};
</script>

<style scoped>
.int-logout-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
}
</style>
